import { render, staticRenderFns } from "./RecuperarSenhaQuestionario.vue?vue&type=template&id=b722e13e&scoped=true"
import script from "./RecuperarSenhaQuestionario.vue?vue&type=script&lang=js"
export * from "./RecuperarSenhaQuestionario.vue?vue&type=script&lang=js"
import style0 from "./RecuperarSenhaQuestionario.vue?vue&type=style&index=0&id=b722e13e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b722e13e",
  null
  
)

export default component.exports